export const InternalSupportIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="currentColor"
    viewBox="0 0 256 256"
  >
    <path d="M200,76a44,44,0,1,0-44,44A44.05,44.05,0,0,0,200,76Zm-44,28a28,28,0,1,1,28-28A28,28,0,0,1,156,104ZM240,172a12,12,0,0,1-12,12H208v16a12,12,0,0,1-12,12H60a12,12,0,0,1-12-12V184H28a12,12,0,0,1-12-12,36,36,0,0,1,36-36h64a8,8,0,0,1,0,16H52a20,20,0,0,0-19.6,16H48a12,12,0,0,1,12,12v16H196V172a12,12,0,0,1,12-12h15.6A20,20,0,0,0,204,144H140a8,8,0,0,1,0-16h64A36,36,0,0,1,240,172Z"></path>
  </svg>
);
